import { Injectable, Signal, signal } from '@angular/core';

export type NotificationType = 'error' | 'success' | 'info';

export interface NotificationMessage {
  id: number;
  type: NotificationType;
  text: string;
  hideTitle?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private _messages = signal<NotificationMessage[]>([]);
  private _nextId = 1;

  readonly messages: Signal<NotificationMessage[]> = this._messages.asReadonly();

  showError(text: string, hideTitle?: boolean): void {
    this.push('error', text, hideTitle);
  }

  showSuccess(text: string): void {
    this.push('success', text);
  }

  showInfo(text: string): void {
    this.push('info', text);
  }

  dismiss(id: number): void {
    this._messages.update((current) => current.filter((m) => m.id !== id));
  }

  private push(type: NotificationType, text: string, hideTitle?: boolean): void {
    const id = this._nextId++;
    const message: NotificationMessage = { id, type, text, hideTitle };

    this._messages.update((current) => [...current, message]);

    // Auto-dismiss after a few seconds for non-critical messages
    setTimeout(() => {
      this.dismiss(id);
    }, 5000);
  }
}

